import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { clearSession, createSession, readSession } from "./session.js";
import { completeSignIn, endSessionUrl, startSignIn } from "./oidc.js";
const Ctx = createContext(null);
export function SessionProvider({ children }) {
    const [session, setSession] = useState(() => readSession());
    const signIn = useCallback((input) => {
        const s = createSession(input);
        setSession(s);
        return s;
    }, []);
    const signInWithLogto = useCallback(async (from) => {
        await startSignIn(from ?? "/workspace");
    }, []);
    const completeOidcSignIn = useCallback(async (search) => {
        const { session: s, from } = await completeSignIn(search);
        setSession(s);
        return from;
    }, []);
    const signOut = useCallback(() => {
        clearSession();
        setSession(null);
    }, []);
    const signOutWithLogto = useCallback(() => {
        const hint = readSession()?.idToken;
        clearSession();
        setSession(null);
        window.location.assign(endSessionUrl(hint));
    }, []);
    const value = useMemo(() => ({ session, signIn, signInWithLogto, completeOidcSignIn, signOut, signOutWithLogto }), [session, signIn, signInWithLogto, completeOidcSignIn, signOut, signOutWithLogto]);
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useSession() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error("useSession must be used inside <SessionProvider>");
    return v;
}
